export const isThirdPageAndPreviouslySelected = (
  noeEntekhab,
  department,
  steps
) => {
  const condition =
    (Number(noeEntekhab) !== 3 && steps === 3) ||
    (department?.NobatBaPezeshKYaVahed === 2 &&
      steps === 3);

  return condition;
};
